import { useState } from "react";
import Box from "@mui/material/Box";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector } from "react-redux";
import store from "../../../../../store";
import {
  setGeoAssociatedTerritoryFilter,
  setGeoTimezoneFilter,
  setSelectedEntityType,
} from "../../../../../features/metaEntitiesSlice";

const GeoFilter = () => {
  const [searchTerritory, setSearchTerritory] = useState<string>("");
  const [searchTimezone, setSearchTimezone] = useState<string>("");

  const { metaEntityList, geoAssociatedTerritoryFilter, geoTimezoneFilter } =
    useSelector((state: any) => state?.metaEntity);

  const filterConfig = [
    {
      key: "Associated Territory",
      label: "Select Associated Territory",
      searchTerm: searchTerritory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTerritory(e.target.value),
      selectedOption: geoAssociatedTerritoryFilter,
      filterName: "territory_name",
      data: metaEntityList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setGeoAssociatedTerritoryFilter(updatedSelection)),
      count:
        geoAssociatedTerritoryFilter && geoAssociatedTerritoryFilter.length,
      colorSelected:
        geoAssociatedTerritoryFilter !== null &&
        geoAssociatedTerritoryFilter?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Timezone",
      label: "Select Timezone",
      searchTerm: searchTimezone,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTimezone(e.target.value),
      selectedOption: geoTimezoneFilter,
      filterName: "timezone",
      data: metaEntityList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setGeoTimezoneFilter(updatedSelection)),
      count: geoTimezoneFilter && geoTimezoneFilter.length,
      colorSelected:
        geoTimezoneFilter !== null && geoTimezoneFilter?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    store.dispatch(setSelectedEntityType(""));
    store.dispatch(setGeoAssociatedTerritoryFilter(null));
    store.dispatch(setGeoTimezoneFilter(null));
    setSearchTerritory("");
    setSearchTimezone("");
  };

  return (
    <Box data-tracker="233">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default GeoFilter;
